import React from 'react'
import { Form } from 'react-bootstrap'

const Select = (
    {
        inputs,
        title,
        articleListOfParent,
        handleChangeSelectorProductFamily,
        index, 
        editArticle,
        handleChange,
        key
    }
) => {

    const _handleChange = (e) => {
        // console.log('editArticle', '_handleChange', e, index);
        if (!editArticle) {
            handleChangeSelectorProductFamily(e, index);
        } else {
            handleChange(e);
        }
    }

    return (
        <>
            {/* FIX: Si no hay elementos, no muestra el Selector */}
            <Form.Group size="lg" style={{ display: articleListOfParent?.length > 0 ? 'block' : 'none' }}>
                <Form.Label className="form__labels">Família/subfamília</Form.Label>
                <Form.Control
                    // id="select-family-subfamily"
                    id={`select-family-subfamily`}
                    as="select"
                    className="user-input form__input"
                    type="text"
                    name={!editArticle ? "id_Articulo" : "id_ArticuloPadre"}
                    value={!editArticle ? inputs.id_Articulo : inputs.id_ArticuloPadre}
                    onChange={_handleChange}
                >
                    <option hidden>Família/subfamília</option>
                    {
                        articleListOfParent?.length > 0 ? articleListOfParent?.map((article, i) =>
                            <option
                                key={i}
                                value={article.id_Articulo}>
                                {article.nombre}
                            </option>
                        ) : null
                    }
                </Form.Control>
            </Form.Group>
        </>
    )
}
export default Select